import { render, staticRenderFns } from "./Prorak.vue?vue&type=template&id=d648db1a&scoped=true"
import script from "./Prorak.vue?vue&type=script&lang=js"
export * from "./Prorak.vue?vue&type=script&lang=js"
import style0 from "./Prorak.vue?vue&type=style&index=0&id=d648db1a&prod&lang=scss&scoped=true"
import style1 from "./Prorak.vue?vue&type=style&index=1&id=d648db1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d648db1a",
  null
  
)

export default component.exports